if (!customElements.get('collection-list')) {
  class CollectionList extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        sliderWrapper: '.collection-list__items',
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      };

      this.classes = {
        grid: 'f-grid',
        swiper: 'swiper',
        swiperWrapper: 'swiper-wrapper',
      };

      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section-${this.sectionId}`);
      this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

      // Collection list section passes its column counts; the slider section uses auto-width slides.
      this.items = parseInt(this.dataset.items) || 0;
      this.laptopItems = parseInt(this.dataset.laptopItems) || this.items;
      this.tabletItems = parseInt(this.dataset.tabletItems) || this.items;

      this.sliderInstance = false;

      const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
      mql.onchange = this.init.bind(this);
      this.init();
    }

    init() {
      if (FoxTheme.config.mqlMobile) {
        this.destroySlider();
      } else {
        this.initSlider();
      }
    }

    initSlider() {
      const sliderOptions = this.items
        ? this.getColumnsSliderOptions()
        : {
            modules: [FoxTheme.Swiper.Navigation, FoxTheme.Swiper.Pagination],
            slidesPerView: 'auto',
            spaceBetween: 8,
            navigation: {
              nextEl: this.section.querySelector(this.selectors.nextEl),
              prevEl: this.section.querySelector(this.selectors.prevEl),
            },
            pagination: false,
            loop: false,
            threshold: 2,
            breakpoints: {
              768: {
                spaceBetween: 20,
              },
            },
          };

      if (typeof this.sliderInstance !== 'object') {
        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);

        this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
        this.sliderInstance.init();

        const focusableElements = FoxTheme.a11y.getFocusableElements(this);

        focusableElements.forEach((element) => {
          element.addEventListener('focusin', () => {
            const slide = element.closest('.swiper-slide');
            this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
          });
        });

        if (Shopify.designMode) {
          document.addEventListener('shopify:block:select', (e) => {
            if (e.detail.sectionId != this.sectionId) return;
            let { target } = e;
            const index = Number(target.dataset.index);

            this.sliderInstance.slider.slideTo(index);
          });
        }
      }
    }

    getColumnsSliderOptions() {
      // Read the gap while the wrapper still has .f-grid, which resolves --f-column-gap.
      const columnGap = window.getComputedStyle(this.sliderWrapper).getPropertyValue('--f-column-gap');
      const spaceBetween = parseFloat(columnGap) * 10 || 0;

      return {
        modules: [FoxTheme.Swiper.Navigation, FoxTheme.Swiper.A11y, FoxTheme.Swiper.Mousewheel],
        slidesPerView: this.tabletItems,
        spaceBetween: spaceBetween,
        navigation: {
          nextEl: this.section.querySelector(this.selectors.nextEl),
          prevEl: this.section.querySelector(this.selectors.prevEl),
        },
        pagination: false,
        loop: false,
        threshold: 2,
        mousewheel: {
          enabled: true,
          forceToAxis: true,
        },
        breakpoints: {
          1024: {
            slidesPerView: this.laptopItems,
          },
          1280: {
            slidesPerView: this.items,
          },
        },
      };
    }

    destroySlider() {
      this.classList.remove(this.classes.swiper);
      this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
      this.sliderWrapper.classList.add(this.classes.grid);
      if (typeof this.sliderInstance !== 'object') return;
      this.sliderInstance.slider.destroy();
      this.sliderInstance = false;
    }
  }
  customElements.define('collection-list', CollectionList);
}
